<div class="la-dashboard" [class.la-dashboard-embedded]="showBackButton" [class.la-dashboard-resizing]="resizingDetailsPanel">
    <header class="la-header la-header-compact">
        <div class="la-header-left">
            <button type="button" class="la-btn la-btn-labeled la-btn-back" *ngIf="showBackButton" title="Back" (click)="onBack()">
                <i class="fas fa-arrow-left" aria-hidden="true"></i>
                <span>Back</span>
            </button>
            <div class="la-search la-search-header" *ngIf="!loading && graphData.nodes.length">
                <span class="la-search-icon">🔍</span>
                <input type="text" placeholder="Search entities…" [ngModel]="searchQuery" (ngModelChange)="onSearchChange($event)" />
            </div>
        </div>

        <div class="la-header-actions" *ngIf="!loading && graphData.nodes.length">
            <button type="button" class="la-btn la-btn-icon" title="Insights" [class.active]="insightsOpen" (click)="toggleInsights()">📊</button>
            <button type="button" class="la-btn la-btn-icon" title="Map" (click)="openMap()">🗺</button>

            <button type="button" class="la-btn la-btn-labeled la-btn-export-pdf" title="Export PDF dossier report" [disabled]="exportingPdf" (click)="exportPdfDossier($event)">
                ⬇ <span>{{ exportingPdf ? 'Exporting…' : 'Export PDF' }}</span>
            </button>

            <div class="la-divider"></div>

            <div class="la-view-toggle">
                <button type="button" title="Network view" [class.active]="viewMode === 'network'" (click)="setViewMode('network')">
                    ⬡ <span>Network</span>
                </button>
                <button type="button" title="Hierarchy view" [class.active]="viewMode === 'tree'" (click)="setViewMode('tree')">
                    🌿 <span>Hierarchy</span>
                </button>
            </div>
            <button type="button" class="la-btn la-btn-icon" title="Hierarchy explorer" [class.active]="treePanelOpen" (click)="toggleTreePanel()">🌳</button>

            <div class="la-divider"></div>

            <button type="button" class="la-btn la-btn-labeled la-btn-stop" *ngIf="showStopAutomation" title="Stop automated expansion" [disabled]="stoppingAutomation" (click)="onStopAutomation()">
                ■ <span>{{ stoppingAutomation ? 'Stopping…' : 'Stop' }}</span>
            </button>
            <button type="button" class="la-btn la-btn-icon la-btn-regenerate" title="Regenerate" (click)="onRegenerate()">↻</button>
        </div>
    </header>

    <div class="la-loader la-loader-overlay" *ngIf="loading">
        <i class="fas fa-spinner fa-spin la-loader-spinner" aria-hidden="true"></i>
        <span class="la-pulse" aria-hidden="true">🕸</span>
        <span>{{ loadingMessage }}</span>
    </div>

    <div class="la-progress-banner" *ngIf="!loading && backgroundProcessing" role="status" aria-live="polite">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
        <span>{{ backgroundProcessingMessage || loadingMessage }}</span>
    </div>

    <div class="la-loader la-loader-overlay error" *ngIf="!loading && errorMessage">{{ errorMessage }}</div>

    <div class="la-loader la-loader-overlay" *ngIf="!loading && !errorMessage && !graphData.nodes.length">
        No graph data was generated for this investigation yet.
    </div>

    <div class="la-graph-body">
        <div class="la-graph-stage" [class.la-graph-stage-details-open]="isPanelOpen && selectedNode">
            <div
                #graphContainer
                class="la-graph-canvas"
                [style.right.px]="isPanelOpen && selectedNode ? effectiveDetailsPanelWidth : 0"
            ></div>
            <div class="la-node-hover-tooltip" *ngIf="hoverTooltipLabel" [style.left.px]="hoverTooltipX" [style.top.px]="hoverTooltipY" role="tooltip">
                {{ hoverTooltipLabel }}
            </div>
            <div class="la-graph-engine-error" *ngIf="graphEngineError">{{ graphEngineError }}</div>

            <div class="la-graph-vtoolbar" *ngIf="graphData.nodes.length && !loading" role="toolbar" aria-label="Graph view controls">
                <button type="button" class="la-zoom-btn" (click)="zoomIn()" title="Zoom In" aria-label="Zoom in">+</button>
                <button type="button" class="la-zoom-btn" (click)="zoomOut()" title="Zoom Out" aria-label="Zoom out">−</button>
                <button type="button" class="la-zoom-btn" (click)="resetView()" title="Fit to View" aria-label="Fit to view">⛶</button>
                <button type="button" class="la-zoom-btn" [class.active]="animateLinks" (click)="toggleAnimateLinks()" title="Toggle Link Flow" aria-label="Toggle link flow">⚡</button>
                <button type="button" class="la-zoom-btn" (click)="fullReset()" title="Reset" aria-label="Reset view">↺</button>
            </div>

            <div class="la-left-rail" *ngIf="graphData.nodes.length && !loading">
                <div class="la-layer-controls la-panel" *ngIf="!insightsOpen" [class.la-layer-collapsed]="entityLayersCollapsed">
                    <button type="button" class="la-layer-title" (click)="toggleEntityLayers()" [attr.aria-expanded]="!entityLayersCollapsed" aria-controls="la-entity-layers-body" title="{{ entityLayersCollapsed ? 'Expand entity layers' : 'Collapse entity layers' }}">
                        <span class="la-layer-title-text">📚 Entity Layers</span>
                        <span class="la-layer-chevron" aria-hidden="true"></span>
                    </button>
                    <div class="la-layer-body" id="la-entity-layers-body" *ngIf="!entityLayersCollapsed">
                        <button type="button" class="la-layer-btn" *ngFor="let type of layerOrder" [class.dim]="!isLayerVisible(type)" (click)="toggleLayer(type)">
                            <span class="la-layer-icon" [style.background]="isLayerVisible(type) ? entityColors[type] + '22' : 'transparent'" [style.border]="'1.5px solid ' + (isLayerVisible(type) ? entityColors[type] : '#555')">
                                {{ entityIcon(type) }}
                            </span>
                            <span>{{ entityLabel(type) }}</span>
                            <span class="ms-auto rounded-circle" [style.width.px]="8" [style.height.px]="8" [style.background]="isLayerVisible(type) ? entityColors[type] : '#555'"></span>
                        </button>
                    </div>
                </div>

                <div class="la-layer-controls la-panel la-branch-layers" *ngIf="viewMode === 'tree' && branchLayers.length && !insightsOpen" [class.la-layer-collapsed]="branchLayersCollapsed">
                    <button type="button" class="la-layer-title" (click)="toggleBranchLayersPanel()" [attr.aria-expanded]="!branchLayersCollapsed" aria-controls="la-branch-layers-body" title="{{ branchLayersCollapsed ? 'Expand branch layers' : 'Collapse branch layers' }}">
                        <span class="la-layer-title-text">🌿 Branch Layers</span>
                        <span class="la-layer-chevron" aria-hidden="true"></span>
                    </button>
                    <div class="la-layer-body" id="la-branch-layers-body" *ngIf="!branchLayersCollapsed">
                        <button type="button" class="la-layer-btn" *ngFor="let branch of branchLayers; trackBy: trackById" [class.dim]="!isBranchExpanded(branch.id)" (click)="toggleBranchLayer(branch.id)" [title]="branch.label">
                            <span class="la-layer-icon la-branch-num-icon" [style.background]="isBranchExpanded(branch.id) ? branch.color + '22' : 'transparent'" [style.border]="'1.5px solid ' + (isBranchExpanded(branch.id) ? branch.color : '#555')">
                                {{ branch.number }}
                            </span>
                            <span class="la-branch-label">{{ branch.label }}</span>
                            <span class="ms-auto rounded-circle" [style.width.px]="8" [style.height.px]="8" [style.background]="isBranchExpanded(branch.id) ? branch.color : '#555'"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="la-isolate-banner" *ngIf="isolatedId">
                <span>🔍 Isolated neighborhood</span>
                <button type="button" class="la-btn" (click)="clearIsolation()">Clear</button>
            </div>

            <aside class="la-tree-panel la-panel" *ngIf="treePanelOpen && tree && graphData.nodes.length && !loading" [style.right.px]="treePanelRightOffset">
                <div class="la-tree-header">
                    <span class="la-tree-title">🌳 Hierarchy Explorer</span>
                    <button type="button" class="la-btn la-btn-compact" *ngIf="rootId" (click)="setRoot(rootId)" title="Reset root">↺ root</button>
                </div>
                <div class="la-tree-body">
                    <ng-container *ngTemplateOutlet="treeRow; context: treeContext(tree, 0)"></ng-container>
                </div>
            </aside>

            <aside #detailsPanel class="la-details-panel" [class.la-details-panel-collapsed]="isPanelCollapsed" *ngIf="isPanelOpen && selectedNode" [style.width.px]="effectiveDetailsPanelWidth">
                <div class="la-panel-resize-handle" title="Drag to resize" *ngIf="!isPanelCollapsed" (mousedown)="onDetailsResizeStart($event)"></div>

                <!-- Face Search–style detail card -->
                <ng-container *ngIf="selectedOsintCard?.kind === 'face'; else defaultOsintDetailCard">
                    <div class="la-face-card" *ngIf="selectedOsintCard as card" [class.is-collapsed]="isPanelCollapsed">
                        <div
                            class="la-face-match-bar"
                            [class.is-high]="isHighFaceMatch(card)"
                            [class.is-low]="!isHighFaceMatch(card)"
                            [class.is-collapsed]="isPanelCollapsed"
                        >
                            <span class="la-face-match-label" *ngIf="!isPanelCollapsed">
                                Match Probability : {{ formatFaceMatchPercent(card) }}
                            </span>
                            <span
                                class="la-face-match-label-compact"
                                *ngIf="isPanelCollapsed"
                                [attr.title]="'Match Probability : ' + formatFaceMatchPercent(card)"
                            >
                                {{ formatFaceMatchPercent(card) }}
                            </span>
                            <div class="la-face-match-actions">
                                <a
                                    *ngIf="!isPanelCollapsed"
                                    class="la-face-nav-btn"
                                    [class.is-disabled]="!getFaceCardImageSrc(card)"
                                    [href]="getFaceCardImageSrc(card) || null"
                                    [attr.target]="getFaceCardImageSrc(card) ? '_blank' : null"
                                    [attr.rel]="getFaceCardImageSrc(card) ? 'noopener noreferrer' : null"
                                    title="View Image"
                                    (click)="!getFaceCardImageSrc(card) ? $event.preventDefault() : $event.stopPropagation()"
                                >
                                    <i class="fas fa-binoculars" aria-hidden="true"></i>
                                </a>
                                <button
                                    type="button"
                                    class="la-face-nav-btn la-face-expand-btn"
                                    [title]="isPanelCollapsed ? 'Expand panel' : 'Collapse panel'"
                                    (click)="toggleDetailsPanelCollapse()"
                                >
                                    <i class="fas" [ngClass]="isPanelCollapsed ? 'fa-chevron-left' : 'fa-chevron-right'" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="la-face-nav-btn la-face-close-btn" title="Close" (click)="closePanel()">
                                    <i class="fas fa-times" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>

                        <div class="la-face-card-body" *ngIf="!isPanelCollapsed">
                            <div class="la-face-preview-section">
                                <span class="la-osint-field-label">Pictures</span>
                                <div class="la-face-preview-frame" [class.is-placeholder]="!getFaceCardImageSrc(card)">
                                    <img
                                        *ngIf="getFaceCardImageSrc(card) as faceSrc; else facePreviewPlaceholder"
                                        class="la-face-preview-img"
                                        [src]="faceSrc"
                                        [alt]="card.title"
                                        referrerpolicy="no-referrer"
                                        (error)="onFaceCardImageError(card, $event)"
                                    />
                                    <ng-template #facePreviewPlaceholder>
                                        <div class="la-face-preview-placeholder">
                                            <i class="fas fa-user" aria-hidden="true"></i>
                                            <span>Image unavailable</span>
                                        </div>
                                    </ng-template>
                                    <button
                                        *ngIf="canStartFaceSearchForCard(card)"
                                        type="button"
                                        class="image-search-trigger is-modal"
                                        (click)="onFaceCardImageSearch(card, $event)"
                                        title="Image Search"
                                        aria-label="Image Search"
                                    >
                                        <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                                        <span>Image Search</span>
                                    </button>
                                </div>
                            </div>

                            <div class="la-face-contexts la-osint-card-body">
                                <div class="la-osint-field" *ngIf="!(card.faceContexts || []).length">
                                    <span class="la-osint-field-label">Details</span>
                                    <div class="la-osint-field-value-row">
                                        <span class="la-osint-field-value">No details found</span>
                                    </div>
                                </div>
                                <div class="la-osint-field" *ngFor="let field of card.faceContexts || []">
                                    <span class="la-osint-field-label">{{ field.label }}</span>
                                    <div class="la-osint-field-value-row">
                                        <ng-container *ngIf="isDetailFieldSearchable(field); else faceContextReadonly">
                                            <button
                                                type="button"
                                                class="la-osint-field-value is-searchable"
                                                (click)="startDetailFieldSearch(field, $event)"
                                                [attr.title]="'Search ' + field.value"
                                            >
                                                {{ field.value }}
                                            </button>
                                        </ng-container>
                                        <ng-template #faceContextReadonly>
                                            <a
                                                *ngIf="field.kind === 'link' && field.href; else faceContextText"
                                                class="la-osint-field-value la-osint-inline-link"
                                                [href]="field.href"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                (click)="$event.stopPropagation()"
                                            >
                                                {{ field.value }}
                                            </a>
                                            <ng-template #faceContextText>
                                                <span class="la-osint-field-value">{{ field.value || 'N/A' }}</span>
                                            </ng-template>
                                        </ng-template>
                                        <ng-container *ngTemplateOutlet="detailFieldSearchControl; context: { field: field }"></ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-template #defaultOsintDetailCard>
                <div class="la-details-header la-osint-card-header" *ngIf="selectedOsintCard as card" [ngStyle]="getOsintCardThemeStyle(card)">
                    <div class="la-details-header-top">
                        <div class="d-flex align-items-center gap-3 la-details-header-main">
                            <ng-container *ngTemplateOutlet="nodeAvatar; context: { node: selectedNode, size: 'md' }"></ng-container>
                            <div class="la-details-title-wrap" *ngIf="!isPanelCollapsed">
                                <div class="la-details-title-row">
                                    <strong class="la-details-title" [class.la-osint-photos-title]="isPhotosHubCard(card) || card.isPhotoHub">{{ card.title }}</strong>
                                    <span class="la-osint-photos-count" *ngIf="isPhotosHubCard(card) || card.isPhotoHub">{{ photosHubTiles.length }} recovered</span>
                                    <span
                                        class="la-details-info-trigger"
                                        *ngIf="selectedNodeInfoSections.length"
                                        tabindex="0"
                                        role="button"
                                        aria-label="View how this was found and leak source details"
                                        [attr.aria-expanded]="infoPopoverOpen"
                                        (mouseenter)="openInfoPopover()"
                                        (mouseleave)="scheduleCloseInfoPopover()"
                                        (focus)="openInfoPopover()"
                                        (blur)="scheduleCloseInfoPopover()"
                                        (click)="$event.stopPropagation()"
                                    >
                                        <i class="fas fa-info-circle la-details-info-icon" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <div class="la-details-type la-osint-card-category" *ngIf="!(isPhotosHubCard(card) || card.isPhotoHub)">{{ card.category }}</div>
                                <p class="la-osint-photos-subtitle" *ngIf="isPhotosHubCard(card) || card.isPhotoHub">All recovered photos for this {{ photosHubSubject }}.</p>
                            </div>
                        </div>
                        <div class="la-details-header-actions">
                            <button type="button" class="la-btn la-btn-compact" *ngIf="isInvestigationRoot(selectedNode?.id)"
                                (click)="requestAddRootNode()">+ Add node</button>
                            <span class="la-osint-status-badge" *ngIf="!isPanelCollapsed" [class.is-found]="card.found" [class.is-missing]="!card.found" [attr.title]="card.found ? 'Found' : 'Not found'">
                                <i class="bi" [ngClass]="card.found ? 'bi-check-circle' : 'bi-x-circle'" aria-hidden="true"></i>
                            </span>
                            <a
                                *ngIf="!isPanelCollapsed && card.profileUrl"
                                class="la-osint-external-link"
                                [href]="card.profileUrl"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open profile"
                            >
                                <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                            </a>
                            <button type="button" class="la-btn la-btn-icon" [title]="isPanelCollapsed ? 'Expand panel' : 'Collapse panel'" (click)="toggleDetailsPanelCollapse()">
                                {{ isPanelCollapsed ? '‹' : '›' }}
                            </button>
                            <button type="button" class="la-btn la-btn-icon la-details-close-btn" title="Close" (click)="closePanel()">×</button>
                        </div>
                        <div
                            class="la-details-info-popover"
                            *ngIf="!isPanelCollapsed && infoPopoverOpen && selectedNodeInfoSections.length"
                            role="tooltip"
                            (mouseenter)="openInfoPopover()"
                            (mouseleave)="scheduleCloseInfoPopover()"
                            (click)="$event.stopPropagation()"
                        >
                            <div class="la-detail-sections">
                                <ng-container *ngFor="let section of selectedNodeInfoSections">
                                    <ng-container *ngTemplateOutlet="detailSection; context: { section: section }"></ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="la-details-header-badges" *ngIf="!isPanelCollapsed">
                        <span class="la-header-badge la-header-badge-root" *ngIf="selectedNode.id === rootId">Root</span>
                        <span class="la-header-badge la-header-badge-tag" *ngFor="let tag of tagKeys" [hidden]="!isTagActive(tag)">
                            {{ tagMeta[tag].label }}
                        </span>
                    </div>
                </div>

                <div class="la-details-body la-osint-card-body" *ngIf="!isPanelCollapsed && selectedOsintCard as card" [ngStyle]="getOsintCardThemeStyle(card)">
                    <div class="la-osint-field la-osint-pictures-field" *ngIf="shouldShowOsintPictures(card) && getOsintCardPicture(card) as platformImage">
                        <span class="la-osint-field-label">Pictures <span class="la-source-photos-count" *ngIf="sourcePhotoThumbnails.length">({{ sourcePhotoThumbnails.length + 1 }})</span></span>
                        <div class="la-osint-picture-wrap">
                            <a
                                #sourcePictureLink
                                id="la-source-primary-photo"
                                class="la-osint-picture-frame"
                                [href]="platformImage.src"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    [src]="platformImage.src"
                                    [alt]="platformImage.name || card.heroImage?.label || card.title"
                                    referrerpolicy="no-referrer"
                                    (error)="onOsintPictureError($event)"
                                />
                            </a>
                            <ng-container *ngIf="sourcePhotoThumbnails.length">
                                <button type="button" class="la-source-photo-nav la-source-photo-prev"
                                    aria-label="Previous photo" title="Previous photo"
                                    (click)="cycleSourcePhoto(card, -1, $event)">‹</button>
                                <button type="button" class="la-source-photo-nav la-source-photo-next"
                                    aria-label="Next photo" title="Next photo"
                                    (click)="cycleSourcePhoto(card, 1, $event)">›</button>
                                <span class="la-source-photo-position" aria-live="polite">{{ getSourcePhotoPosition(card) }} / {{ sourcePhotoThumbnails.length + 1 }}</span>
                            </ng-container>
                            <button
                                *ngIf="canStartImageSearch(platformImage)"
                                type="button"
                                class="image-search-trigger"
                                (click)="startImageSearchFromSrc(platformImage, $event)"
                                title="Image Search"
                                aria-label="Image Search"
                            >
                                <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                    <p class="la-osint-description" *ngIf="card.description">{{ card.description }}</p>

                    <ng-container *ngIf="card.kind === 'leak'; else osintCardFields">
                        <div class="la-osint-field" *ngFor="let field of card.fields">
                            <span class="la-osint-field-label">{{ field.label }}</span>
                            <div class="la-osint-field-value-row">
                                <button
                                    *ngIf="isDetailFieldSearchable(field); else leakMetaReadonly"
                                    type="button"
                                    class="la-osint-field-value is-searchable"
                                    (click)="startDetailFieldSearch(field, $event)"
                                    [attr.title]="'Search ' + field.value"
                                >
                                    {{ field.value }}
                                </button>
                                <ng-template #leakMetaReadonly>
                                    <span class="la-osint-field-value">{{ field.value || 'N/A' }}</span>
                                </ng-template>
                                <ng-container *ngTemplateOutlet="detailFieldSearchControl; context: { field: field }"></ng-container>
                            </div>
                        </div>

                        <div class="la-leak-data-section" *ngFor="let record of card.leakRecords || []">
                            <div class="la-leak-data-header">{{ record.label }}</div>
                            <div class="la-leak-data-grid">
                                <div class="la-leak-data-row" *ngFor="let field of record.fields">
                                    <div class="la-leak-field-content">
                                        <span class="la-osint-field-label">{{ field.label }}</span>
                                        <div class="la-osint-field-value-row">
                                            <ng-container *ngIf="isDetailFieldSearchable(field); else leakFieldReadonly">
                                                <button
                                                    type="button"
                                                    class="la-osint-field-value is-searchable"
                                                    (click)="startDetailFieldSearch(field, $event)"
                                                    [attr.title]="'Search ' + field.value"
                                                >
                                                    {{ field.value }}
                                                </button>
                                            </ng-container>
                                            <ng-template #leakFieldReadonly>
                                                <a
                                                    *ngIf="field.kind === 'link' && field.href; else leakFieldText"
                                                    class="la-osint-field-value la-osint-inline-link"
                                                    [href]="field.href"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    (click)="$event.stopPropagation()"
                                                >
                                                    {{ field.value }}
                                                </a>
                                                <ng-template #leakFieldText>
                                                    <span class="la-osint-field-value">{{ field.value || 'N/A' }}</span>
                                                </ng-template>
                                            </ng-template>
                                            <ng-container *ngTemplateOutlet="detailFieldSearchControl; context: { field: field }"></ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-template #osintCardFields>
                        <div class="la-osint-field" *ngFor="let field of card.fields">
                            <span class="la-osint-field-label">{{ field.label }}</span>
                            <div class="la-osint-field-value-row">
                                <div class="la-osint-field-main">
                                    <ng-container *ngIf="isAggregateJumpField(field); else osintFieldSearchOrReadonly">
                                        <button
                                            type="button"
                                            class="la-osint-field-value is-searchable"
                                            (click)="onAggregateEntryJump(field, $event)"
                                            [attr.title]="'Open on ' + (field.subValue || 'source')"
                                        >
                                            {{ field.value }}
                                        </button>
                                        <span class="la-osint-field-sub" *ngIf="field.subValue">{{ field.subValue }}</span>
                                    </ng-container>
                                    <ng-template #osintFieldSearchOrReadonly>
                                    <ng-container *ngIf="isDetailFieldSearchable(field); else osintFieldReadonly">
                                        <button
                                            type="button"
                                            class="la-osint-field-value is-searchable"
                                            (click)="startDetailFieldSearch(field, $event)"
                                            [attr.title]="'Search ' + field.value"
                                        >
                                            {{ field.value }}
                                        </button>
                                    </ng-container>
                                    <ng-template #osintFieldReadonly>
                                        <a *ngIf="field.kind === 'link' && field.href; else osintFieldValue" class="la-osint-field-value la-osint-inline-link" [href]="field.href" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                                            {{ field.value }}
                                        </a>
                                        <ng-template #osintFieldValue>
                                            <div class="la-osint-chips" *ngIf="field.kind === 'chips' && field.chips?.length; else osintTextValue">
                                                <span class="la-osint-chip" *ngFor="let chip of field.chips">{{ chip }}</span>
                                            </div>
                                            <ng-template #osintTextValue>
                                                <span class="la-osint-field-value">{{ field.value || 'N/A' }}</span>
                                            </ng-template>
                                        </ng-template>
                                    </ng-template>
                                    <span class="la-osint-field-sub" *ngIf="field.subValue">{{ field.subValue }}</span>
                                    </ng-template>
                                </div>
                                <ng-container *ngTemplateOutlet="detailFieldSearchControl; context: { field: field }"></ng-container>
                            </div>
                        </div>
                    </ng-template>

                    <div class="la-osint-photos-grid" *ngIf="(isPhotosHubCard(card) || card.isPhotoHub) && photosHubTiles.length">
                        <div class="la-osint-photos-item" *ngFor="let tile of photosHubTiles">
                            <button
                                type="button"
                                class="la-osint-photos-open"
                                (click)="onPhotosHubTileClick(tile)"
                                [attr.aria-label]="'Open photo from ' + (tile.image.platform || tile.image.name || 'source')"
                            >
                                <img
                                    *ngIf="tile.image.src"
                                    [src]="tile.image.src"
                                    [alt]="tile.image.platform || tile.image.name || 'Photo'"
                                    referrerpolicy="no-referrer"
                                    (error)="onOsintPictureError($event)"
                                />
                                <i *ngIf="!tile.image.src" class="bi bi-image" aria-hidden="true"></i>
                                <span class="la-osint-photos-platform" *ngIf="tile.image.platform">{{ tile.image.platform }}</span>
                            </button>
                            <button
                                *ngIf="canStartImageSearch(tile.image)"
                                type="button"
                                class="image-search-trigger"
                                (click)="startImageSearchFromSrc(tile.image, $event)"
                                title="Image Search"
                                aria-label="Image Search"
                            >
                                <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div class="la-osint-photos-empty" *ngIf="(isPhotosHubCard(card) || card.isPhotoHub) && !photosHubTiles.length">
                        No photos available.
                    </div>

                    <div class="la-osint-related-grid" *ngIf="!(isPhotosHubCard(card) || card.isPhotoHub) && card.relatedItems.length">
                        <button type="button" class="la-osint-related-card" *ngFor="let item of card.relatedItems" (click)="onRelatedIdentityClick(item.id)">
                            <span class="la-osint-related-thumb">
                                <img
                                    *ngIf="getRelatedItemPicture(item) as relatedImage"
                                    [src]="relatedImage.src"
                                    [alt]="item.label"
                                    referrerpolicy="no-referrer"
                                    (error)="onOsintPictureError($event)"
                                />
                                <i *ngIf="!getRelatedItemPicture(item)" [class]="card.placeholderIcon" aria-hidden="true"></i>
                            </span>
                            <span class="la-osint-related-text">
                                <strong>{{ item.label }}</strong>
                                <small *ngIf="item.subtitle">{{ item.subtitle }}</small>
                            </span>
                        </button>
                    </div>

                    <section class="la-source-photos" *ngIf="sourcePhotoThumbnails.length" aria-label="More photos">
                        <div class="la-section-title">More photos <span class="la-source-photos-count">{{ sourcePhotoThumbnails.length }}</span></div>
                        <div class="la-source-photos-grid">
                            <div class="la-osint-photos-item la-source-photo-tile" *ngFor="let photo of sourcePhotoThumbnails; let i = index; trackBy: trackSourcePhoto">
                                <button
                                    type="button"
                                    class="la-osint-photos-open"
                                    (click)="selectSourcePhoto(photo, $event)"
                                    [attr.aria-label]="'View photo ' + (i + 2)"
                                    aria-controls="la-source-primary-photo"
                                >
                                    <img [src]="photo.src" [alt]="photo.name || 'Collected photo'" loading="lazy" referrerpolicy="no-referrer" (error)="onOsintPictureError($event)" />
                                </button>
                                <button *ngIf="canStartImageSearch(photo)" type="button" class="image-search-trigger" (click)="startImageSearchFromSrc(photo, $event)" title="Image Search" aria-label="Image Search">
                                    <i class="fas fa-magnifying-glass" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    <div class="la-detail-block">
                        <div class="la-detail-block-title la-section-title">Notes</div>
                        <textarea class="la-note-area" [(ngModel)]="noteDraft" (blur)="saveNote()"></textarea>
                        <small class="la-note-saved" *ngIf="noteSaved">Saved</small>
                    </div>

                    <div class="la-details-footer">
                        <div class="la-tag-row">
                            <button type="button" class="la-tag-btn" *ngFor="let tag of tagKeys" [style.border-color]="isTagActive(tag) ? tagMeta[tag].color + '88' : ''" [style.background]="isTagActive(tag) ? tagMeta[tag].color + '22' : 'transparent'" [style.color]="isTagActive(tag) ? tagMeta[tag].color : null" (click)="setTag(tag)">
                                {{ tagMeta[tag].label }}
                            </button>
                        </div>
                    </div>
                </div>
                </ng-template>
            </aside>

            <section class="la-floating-panel la-panel la-insights" *ngIf="insightsOpen">
                <div class="la-panel-header">
                    <span>📊 Investigation Insights</span>
                    <button type="button" class="la-btn" (click)="toggleInsights()">×</button>
                </div>
                <div class="la-panel-body">
                    <div class="la-section-title">Risk Distribution</div>
                    <div class="la-risk-grid mb-4">
                        <div class="la-risk-card"><strong style="color:#EF4444">{{ insightsRiskCounts['high'] }}</strong><span>High</span></div>
                        <div class="la-risk-card"><strong style="color:#F59E0B">{{ insightsRiskCounts['medium'] }}</strong><span>Medium</span></div>
                        <div class="la-risk-card"><strong style="color:#10B981">{{ insightsRiskCounts['low'] }}</strong><span>Low</span></div>
                    </div>

                    <div class="la-section-title">Entity Distribution</div>
                    <div class="mb-4" *ngFor="let type of layerOrder">
                        <div class="la-bar-row" *ngIf="insightsTypeDist[type]">
                            <span>{{ entityIcon(type) }}</span>
                            <span style="width: 96px;">{{ entityLabel(type) }}</span>
                            <div class="la-bar-track">
                                <div class="la-bar-fill" [style.width.%]="(insightsTypeDist[type] / insightsMaxType) * 100" [style.background]="entityColors[type]"></div>
                            </div>
                            <span>{{ insightsTypeDist[type] }}</span>
                        </div>
                    </div>

                    <div class="la-section-title">Most Connected</div>
                    <button type="button" class="la-connected-item mb-2" *ngFor="let item of insightsTopNodes; let i = index" (click)="selectNode(item.node.id)">
                        <span>#{{ i + 1 }}</span>
                        <span class="flex-grow-1">{{ item.node.label }}</span>
                        <span>{{ item.degree }}</span>
                    </button>
                </div>
            </section>

            <section class="la-floating-panel la-panel la-correlation" *ngIf="correlationOpen">
                <div class="la-panel-header">
                    <span>🔗 Correlations ({{ correlations.length }})</span>
                    <button type="button" class="la-btn" (click)="closeCorrelation()">×</button>
                </div>
                <div class="la-panel-body">
                    <button type="button" class="la-connected-item mb-2" *ngFor="let cor of correlations" (click)="highlightCorrelation(cor.nodeIds)">
                        <strong class="d-block">{{ cor.attribute }}</strong>
                        <small>{{ cor.type }} · {{ cor.strength }}</small>
                    </button>
                </div>
            </section>

            <section class="la-floating-panel la-panel la-timeline" *ngIf="timelineOpen">
                <div class="la-panel-header">
                    <span>🕐 Discovery Timeline</span>
                    <div class="d-flex align-items-center gap-2">
                        <small>{{ timelineTotalVisible }}/{{ graphData.nodes.length }} entities</small>
                        <button type="button" class="la-btn" (click)="closeTimeline()">×</button>
                    </div>
                </div>
                <div class="la-panel-body">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>{{ timelineDates[timelineStepIndex] }}</strong>
                        <div class="d-flex gap-1 flex-wrap">
                            <span class="badge bg-secondary" *ngFor="let n of timelineNewAtStep | slice:0:5">{{ n.label }}</span>
                        </div>
                    </div>
                    <input type="range" class="form-range" [min]="0" [max]="timelineDates.length - 1" [(ngModel)]="timelineStepIndex" (ngModelChange)="onTimelineStepChange($event)" />
                    <div class="d-flex justify-content-center gap-2 mt-3">
                        <button type="button" class="la-btn" (click)="onTimelineStepChange(0)">⏮</button>
                        <button type="button" class="la-btn primary" (click)="toggleTimelinePlay()">{{ timelinePlaying ? '⏸' : '▶' }}</button>
                        <button type="button" class="la-btn" (click)="showAllTimeline()">⏭</button>
                    </div>
                </div>
            </section>

            <div class="la-map-overlay" *ngIf="mapOpen">
                <button type="button" class="la-btn" style="position:absolute;top:12px;left:50%;transform:translateX(-50%);z-index:1000;" (click)="closeMap()">× Close map</button>
                <div class="la-map-status" *ngIf="mapLoading">Loading locations…</div>
                <div class="la-map-status la-map-status-empty" *ngIf="!mapLoading && mapMarkerCount === 0">No mappable locations found in this investigation.</div>
                <div #mapContainer class="la-map-container"></div>
            </div>
        </div>

        <footer class="la-graph-footer" *ngIf="graphData.nodes.length && !loading">
            <div class="la-footer-toolbar">
                <div class="la-stats-bottom">
                    <span>● {{ filteredNodes.length }}/{{ graphData.nodes.length }} nodes</span>
                    <span class="la-stats-sep">|</span>
                    <span>↗ {{ filteredLinks.length }}/{{ graphData.edges.length }} edges</span>
                </div>
                <div class="la-footer-divider la-footer-divider-toolbar"></div>
                <div class="la-hop-bar" title="Filter graph depth (layers from root)">
                    <span class="la-hop-label">
                        <span class="la-hop-icon" aria-hidden="true"></span>
                        Hops
                    </span>
                    <button type="button" class="la-hop-btn" [class.active]="hopFilter === null" (click)="setHopFilter(null)">All</button>
                    <button type="button" class="la-hop-btn" [class.active]="hopFilter === 1" (click)="setHopFilter(1)">1</button>
                    <button type="button" class="la-hop-btn" [class.active]="hopFilter === 2" (click)="setHopFilter(2)">2</button>
                    <button type="button" class="la-hop-btn" [class.active]="hopFilter === 3" (click)="setHopFilter(3)">3</button>
                </div>
            </div>
        </footer>
    </div>

    <div class="la-node-search-popover" *ngIf="searchPopover && shouldShowSearchPopover()" [style.left.px]="searchPopover.x" [style.top.px]="searchPopover.y" (click)="$event.stopPropagation()">
        <div class="la-node-search-popover-header" (pointerdown)="onSearchPopoverHeaderPointerDown($event)">
            <span class="la-popover-drag" aria-hidden="true">⋮</span>
            <span class="la-node-search-popover-title">{{ searchPopover.node.label }}</span>
            <button type="button" class="la-popover-close" (click)="closeSearchPopover()" aria-label="Close">×</button>
        </div>
        <div class="la-node-search-popover-body">
            <button type="button" class="la-btn" *ngIf="isInvestigationRoot(searchPopover.nodeId)"
                (click)="requestAddRootNode()">+ Add node</button>
            <p class="la-search-hint" *ngIf="searchAvailabilityLabel">{{ searchAvailabilityLabel }}</p>
            <div class="la-starter-search" *ngIf="showStarterSearch">
                <div class="la-starter-type-row">
                    <button type="button" class="la-search-chip" [class.active]="starterQueryType === 'phone'" (click)="onStarterQueryTypeSelect('phone')">Phone</button>
                    <button type="button" class="la-search-chip" [class.active]="starterQueryType === 'email'" (click)="onStarterQueryTypeSelect('email')">Email</button>
                    <button type="button" class="la-search-chip" [class.active]="starterQueryType === 'username'" (click)="onStarterQueryTypeSelect('username')">Username</button>
                </div>
                <input type="text" class="la-starter-input" [ngModel]="starterQueryValue" (ngModelChange)="onStarterQueryValueChange($event)" placeholder="Enter search value" />
                <button type="button" class="la-node-search-action highlight" [disabled]="starterActionRunning" (click)="onRunStarterSearch()">
                    {{ starterActionRunning ? 'Running...' : 'Start search' }}
                </button>
            </div>

            <div class="la-action-section" *ngIf="isAggregatePopover && aggregateViewItems.length">
                <div class="la-action-section-label">{{ aggregateViewSectionLabel }}</div>
                <div class="la-aggregate-view-list">
                    <button
                        type="button"
                        class="la-aggregate-view-row"
                        *ngFor="let item of aggregateViewItems; trackBy: trackAggregateViewItem"
                        [class.is-jumpable]="!!item.sourceNodeId"
                        (click)="onAggregatePopoverItemClick(item, $event)"
                    >
                        <span class="la-aggregate-view-text">{{ item.label }}</span>
                    </button>
                </div>
            </div>

            <div class="la-action-section" *ngIf="!isAggregatePopover && valueOptions.length">
                <div class="la-action-section-label">Select value</div>
                <label
                    class="la-radio-option"
                    [class.la-radio-option-image]="option.type === 'image'"
                    *ngFor="let option of valueOptions; trackBy: trackSearchValueOption"
                    (click)="$event.stopPropagation()"
                >
                    <input type="checkbox" [value]="option.value" [checked]="isSearchValueSelected(option.value)" (click)="$event.stopPropagation()" (change)="onSearchValueSelectionChange(option.value, $event)" />
                    <span class="la-radio-option-content">
                        <span class="la-search-value-option-type">{{ option.type }}</span>
                        <img
                            *ngIf="option.type === 'image'"
                            class="la-search-value-thumb"
                            [src]="getSearchValueImageSrc(option)"
                            alt="Search image"
                            referrerpolicy="no-referrer"
                            (error)="onSearchValueImageError($event)"
                        />
                        <span *ngIf="option.type !== 'image'" class="la-radio-option-text">{{ option.label }}</span>
                    </span>
                </label>
            </div>

            <div class="la-action-section" *ngIf="!isAggregatePopover && popoverNodeActions.length">
                <div class="la-action-section-label">Select action</div>
                <label class="la-radio-option" *ngFor="let action of popoverNodeActions; trackBy: trackNodeAction" [class.is-disabled]="action.disabled || action.running" (click)="$event.stopPropagation()">
                    <input type="checkbox" [value]="action.key" [checked]="isActionKeySelected(action.key)" [disabled]="action.disabled || action.running" (click)="$event.stopPropagation()" (change)="onActionKeySelectionChange(action.key, $event)" />
                    <span class="la-radio-option-content">
                        <span class="la-radio-option-text">{{ popoverActionLabel(action) }}{{ action.completed ? ' — Completed' : action.running ? ' — Running...' : action.completedValues?.length ? ' — ' + action.completedValues?.length + ' completed' : '' }}</span>
                    </span>
                </label>
            </div>
        </div>

        <div class="la-node-search-popover-footer" *ngIf="!isAggregatePopover && (popoverNodeActions.length || canRunAi)">
            <button type="button" class="la-node-search-action highlight" *ngIf="popoverNodeActions.length" [disabled]="!canRunSelectedAction" (click)="onRunSelectedAction()">
                {{ runSelectedActionsLabel }}
            </button>

            <button type="button" class="la-node-search-action highlight" *ngIf="canRunAi" [disabled]="aiRunning" (click)="onRunAi()">
                {{ aiRunning ? 'Running AI...' : 'AI analysis' }}
            </button>
        </div>
    </div>

    <div class="la-cmd-overlay" *ngIf="cmdOpen" (click)="closeCommandPalette()">
        <div class="la-cmd-dialog" (click)="$event.stopPropagation()">
            <input class="la-cmd-input" placeholder="Search entities or run an action…" [(ngModel)]="cmdQuery" (ngModelChange)="onCmdQueryChange()" (keydown)="onCmdKeydown($event)" autofocus />
            <div class="la-cmd-list">
                <div class="la-cmd-group-title">Results</div>
                <button type="button" class="la-cmd-item" *ngFor="let item of cmdItems; let i = index" [class.focused]="i === cmdFocusedIndex" (click)="runCmdItem(i)">
                    <span>{{ item.label }}</span>
                    <small *ngIf="item.hint">{{ item.hint }}</small>
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #detailFieldSearchControl let-field="field">
    <button
        *ngIf="isDetailFieldSearchable(field)"
        type="button"
        class="la-detail-field-search-btn"
        [class.is-open]="isDetailFieldSearchFocused(field)"
        title="Search this value"
        aria-label="Search this value"
        (click)="startDetailFieldSearch(field, $event)"
    >
        <i class="fas fa-search" aria-hidden="true"></i>
    </button>
</ng-template>

<ng-template #detailSection let-section="section">
    <div class="la-detail-section" [class.la-detail-section-cards]="section.layout === 'cards'" [class.la-detail-section-compact]="section.layout === 'compact'">
        <div class="la-detail-section-head">
            <span class="la-detail-section-icon" *ngIf="section.icon">{{ section.icon }}</span>
            <div class="la-section-title la-detail-section-title">{{ section.title }}</div>
        </div>
        <div class="la-detail-fields" [class.la-detail-fields-cards]="section.layout === 'cards'" [class.la-detail-fields-compact]="section.layout === 'compact'">
            <div class="la-detail-field" [class.la-detail-field-chips]="field.kind === 'chips'" [class.la-detail-field-account]="field.kind === 'account'" [class.la-detail-field-longtext]="field.kind === 'longtext'" [class.la-detail-field-link]="field.kind === 'link'" [class.la-detail-field-source]="field.kind === 'source'" *ngFor="let field of section.fields">
                <label *ngIf="field.kind !== 'source'">{{ field.label }}</label>

                <div class="la-detail-source-card" *ngIf="field.kind === 'source'">
                    <span class="la-detail-source-type" [attr.data-tone]="field.tone || 'default'">{{ field.label }}</span>
                    <div class="la-detail-source-body">
                        <a *ngIf="field.href; else sourcePlain" class="la-detail-source-title la-detail-link" [href]="field.href" target="_blank" rel="noopener noreferrer" [attr.data-entity-tone]="getDetailValueEntityType(field.value)" (click)="$event.stopPropagation()">
                            {{ field.value }}
                        </a>
                        <ng-template #sourcePlain>
                            <div class="la-detail-source-title" [attr.data-entity-tone]="getDetailValueEntityType(field.value)">{{ field.value }}</div>
                        </ng-template>
                        <div class="la-detail-source-meta" *ngIf="field.subValue">{{ field.subValue }}</div>
                    </div>
                </div>

                <div class="la-detail-account" *ngIf="field.kind === 'account'">
                    <a *ngIf="field.href; else accountPlain" class="la-detail-account-name la-detail-link" [href]="field.href" target="_blank" rel="noopener noreferrer" [attr.data-entity-tone]="getDetailValueEntityType(field.value)" (click)="$event.stopPropagation()">
                        {{ field.value }}
                    </a>
                    <ng-template #accountPlain>
                        <div class="la-detail-account-name" [attr.data-entity-tone]="getDetailValueEntityType(field.value)">{{ field.value }}</div>
                    </ng-template>
                    <div class="la-detail-account-sub" *ngIf="field.subValue">{{ field.subValue }}</div>
                </div>

                <p class="la-detail-longtext" *ngIf="field.kind === 'longtext'" [attr.data-entity-tone]="getDetailValueEntityType(field.value)">
                    {{ field.value }}
                    <span class="la-detail-longtext-sub" *ngIf="field.subValue">{{ field.subValue }}</span>
                    <a *ngIf="field.href" class="la-detail-link d-block mt-1" [href]="field.href" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                        View on map
                    </a>
                </p>

                <ng-container *ngIf="field.kind !== 'account' && field.kind !== 'longtext' && field.kind !== 'source'">
                    <div class="la-detail-field-value-row">
                        <ng-container *ngIf="isAggregateJumpField(field); else detailFieldSearchOrReadonly">
                            <button
                                type="button"
                                class="la-detail-value is-searchable"
                                (click)="onAggregateEntryJump(field, $event)"
                                [attr.title]="'Open on ' + (field.subValue || 'source')"
                            >
                                {{ field.value }}
                            </button>
                            <span class="la-detail-subvalue" *ngIf="field.subValue">{{ field.subValue }}</span>
                        </ng-container>
                        <ng-template #detailFieldSearchOrReadonly>
                        <ng-container *ngIf="isDetailFieldSearchable(field); else detailFieldReadonly">
                            <button
                                type="button"
                                class="la-detail-value is-searchable"
                                (click)="startDetailFieldSearch(field, $event)"
                                [attr.title]="'Search ' + field.value"
                            >
                                {{ field.value }}
                            </button>
                        </ng-container>
                        <ng-template #detailFieldReadonly>
                            <a *ngIf="field.kind === 'link' && field.href; else detailFieldValue" class="la-detail-link" [href]="field.href" target="_blank" rel="noopener noreferrer" [attr.data-entity-tone]="getDetailValueEntityType(field.value) || 'url'" (click)="$event.stopPropagation()">
                                {{ field.value }}
                            </a>
                            <ng-template #detailFieldValue>
                                <div class="la-detail-chips" *ngIf="field.kind === 'chips' && field.chips?.length; else detailTextValue">
                                    <span class="la-detail-chip" *ngFor="let chip of field.chips" [attr.data-entity-tone]="getDetailValueEntityType(chip)">{{ chip }}</span>
                                </div>
                                <ng-template #detailTextValue>
                                    <span class="la-detail-value" [class.la-detail-badge]="field.kind === 'badge'" [attr.data-tone]="field.tone || 'default'" [attr.data-entity-tone]="field.kind === 'badge' ? null : getDetailValueEntityType(field.value)">
                                        {{ field.value }}
                                    </span>
                                    <span class="la-detail-subvalue" *ngIf="field.subValue">{{ field.subValue }}</span>
                                </ng-template>
                            </ng-template>
                        </ng-template>
                        </ng-template>
                        <ng-container *ngTemplateOutlet="detailFieldSearchControl; context: { field: field }"></ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #nodeAvatar let-node="node" let-size="size">
    <div class="la-node-avatar" [class.la-node-avatar-sm]="size === 'sm'" [style.--avatar-color]="getNodeAvatarColor(node)">
        <ng-container *ngIf="hasNodeImage(node); else brandOrPlaceholder">
            <img [src]="displayNodeImage(node)" [alt]="node.label" referrerpolicy="no-referrer" (error)="onNodeImageError(node.id)" />
        </ng-container>
        <ng-template #brandOrPlaceholder>
            <ng-container *ngIf="getNodeBrandIconUrl(node) as brandIcon; else typePlaceholder">
                <img class="la-node-avatar-brand" [class.is-photo-logo]="!brandIcon.startsWith('data:')" [src]="brandIcon" [alt]="node.label" />
            </ng-container>
            <ng-template #typePlaceholder>
                <div class="la-node-avatar-placeholder" aria-hidden="true">
                    <span class="la-node-avatar-icon">{{ entityIcon(node.type) }}</span>
                    <span class="la-node-avatar-initials" *ngIf="size !== 'sm'">{{ getNodeInitials(node.label) }}</span>
                </div>
            </ng-template>
        </ng-template>
    </div>
</ng-template>

<ng-template #treeRow let-node let-depth="depth">
    <div class="la-tree-row" [class.selected]="isTreeNodeSelected(node.node.id)" [style.padding-left.px]="depth * 12 + 4">
        <ng-container *ngIf="getBranchLayerItem(node.node.id) as branch">
            <span class="la-tree-branch-num" [class.dim]="!isBranchExpanded(branch.id)" [style.border-color]="isBranchExpanded(branch.id) ? branch.color : '#555'" [style.color]="isBranchExpanded(branch.id) ? branch.color : '#888'">{{ branch.number }}</span>
        </ng-container>
        <span class="la-tree-expand-spacer" *ngIf="!getBranchLayerItem(node.node.id) && node.children.length"></span>
        <button type="button" class="la-tree-node-btn" (click)="selectNode(node.node.id)">
            <ng-container *ngTemplateOutlet="nodeAvatar; context: { node: node.node, size: 'sm' }"></ng-container>
            <span class="flex-grow-1 la-tree-label">
                <span class="la-tree-label-text">{{ node.node.label }}</span>
                <small *ngIf="node.relation">{{ node.relation }}</small>
            </span>
        </button>
    </div>
    <ng-container *ngIf="viewMode !== 'tree' || !isHierarchyNodeCollapsed(node.node.id)">
        <ng-container *ngIf="!isIdentityHub(node.node)">
            <ng-container *ngFor="let child of node.children">
                <ng-container *ngTemplateOutlet="treeRow; context: treeContext(child, depth + 1)"></ng-container>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>
